/* TODO: t() */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component } from 'react';
import autobind from 'class-autobind';
import { StripeProvider } from 'react-stripe-elements';

import StripePayment from './StripePayment';
import LoadingIndicator from '../../uiold/LoadingIndicator';
import { postJSON } from '../../../support/Fetch';
import { loadScript } from '../../../support/Utils';
import { showError } from '../../App/AppAlert';

import { STRIPE_API_KEY } from '../../../support/shared/constants/Constants';

import { PaymentMethodType } from '../../../types/shared/FormDefinition';
import { PaymentSpringFormFields } from '../../../types/shared/PaymentSpring';
import { Alert } from '../../uiold';
import PaymentSpringForm from './PaymentSpringPayment';
import {
  createPaymentSpringToken,
  PaymentSpringRequiredAchTokenParams,
} from '../../Settings/paymentspring/helpers';
import { PaymentSpringAchForm } from './PaymentSpringAchForm';

type Props = {
  paymentProvider: PaymentMethodType;
  accountID: string;
  vendorID: string;
  // TODO: The following three props seem redundant, we should consolidate.
  formattedPrice: string | null | undefined;
  totalPriceString: string | null | undefined;
  /** The number in float form, e.g. 1.37 */
  totalPriceNumber?: number | null | undefined;
  onSuccess?: () => void;
  onClose?: () => void;
  // TODO: Rename this
  paymentspring_public_api_key?: string;
  invoiceId?: string;
  achOnly: boolean;
};

type Stripe = stripe.Stripe;
type Token = stripe.Token;

type State = {
  formStatus: 'FORM_VISIBLE' | 'SUBMITTING' | 'SUCCESS' | 'ERROR';
  formError: string | null | undefined;
  stripe: Stripe | null;
  paymentSpring: PaymentSpringFormFields;
  paymentSpringAch: PaymentSpringRequiredAchTokenParams;
  showAch: boolean;
};

type DataType = {
  success: boolean;
  responseData?: ObjectOf<unknown>;
  statusCode?: number;
  error?: string;
};

type Charge =
  | { type: 'STRIPE'; token: Token }
  | { type: 'PAYMENTSPRING'; token: unknown };

let stripePromise: Promise<Stripe> | null = null;

function loadStripe(): Promise<Stripe> {
  if (stripePromise == null) {
    stripePromise = loadScript('https://js.stripe.com/v3/').then(() => {
      return window.Stripe(STRIPE_API_KEY);
    });
  }
  return stripePromise;
}

class PaymentForm extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    autobind(this);
    this.state = {
      formStatus: 'FORM_VISIBLE',
      formError: null,
      stripe: null,
      paymentSpring: {
        card_exp_month: '',
        card_exp_year: '',
        cvv: '',
        card_number: '',
        token_type: 'credit_card',
      },
      paymentSpringAch: {
        token_type: 'bank_account',
        bank_account_number: '',
        bank_routing_number: '',
        bank_account_holder_first_name: '',
        bank_account_holder_last_name: '',
        bank_account_type: 'checking',
      },
      showAch: false,
    };
  }

  componentDidMount() {
    if (this.props.paymentProvider === 'STRIPE') {
      this._loadStripe();
    }
    if (this.props.achOnly) {
      this.setState({ showAch: true });
    }
  }

  async _loadStripe() {
    let stripe = await loadStripe();
    this.setState({ stripe: stripe });
  }

  render() {
    if (this.props.formattedPrice == null) {
      return null;
    }
    switch (this.props.paymentProvider) {
      case 'STRIPE': {
        return this._renderStripeForm();
      }
      case 'PAYMENTSPRING': {
        if (this.props.achOnly || this.state.showAch) {
          return this._renderPaymentSpringAchForm();
        }
        return this._renderPaymentSpringForm();
      }
    }
  }

  _renderStripeForm() {
    let { formStatus, stripe } = this.state;
    switch (formStatus) {
      case 'FORM_VISIBLE':
        return (
          <div className="stripePayment">
            <div className="std-form embedded-form">
              <StripeProvider stripe={stripe}>
                <StripePayment
                  onSubmit={(token) =>
                    this._submitCharge({ type: 'STRIPE', token })
                  }
                  formattedPrice={this.props.formattedPrice || ''}
                />
              </StripeProvider>
            </div>
          </div>
        );
      case 'SUBMITTING':
        return (
          <div className="stripePayment">
            <div className="std-form embedded-form">
              <LoadingIndicator />
            </div>
          </div>
        );
      case 'SUCCESS': {
        return this._renderFormSuccess();
      }
      case 'ERROR':
        return this._renderFormError();
      default:
        return null;
    }
  }

  _renderPaymentSpringForm() {
    let { formStatus } = this.state;
    switch (formStatus) {
      case 'FORM_VISIBLE':
        return (
          <div className="stripePayment">
            <div className="std-form embedded-form">
              <PaymentSpringForm
                onSubmit={() =>
                  this._submitCharge({
                    type: 'PAYMENTSPRING',
                    token: {},
                  })
                }
                formattedPrice={this.props.formattedPrice || ''}
                totalPrice={this.props.totalPriceString || ''}
                handleFormChange={this._handleFormChange}
                formFields={this.state.paymentSpring}
                onAltPaymentClick={() => this.setState({ showAch: true })}
              />
            </div>
          </div>
        );
      case 'SUBMITTING':
        return (
          <div className="stripePayment">
            <div className="std-form embedded-form">
              <LoadingIndicator />
            </div>
          </div>
        );
      case 'SUCCESS': {
        return this._renderFormSuccess();
      }
      case 'ERROR':
        return this._renderFormError();
      default:
        return null;
    }
  }

  _renderPaymentSpringAchForm() {
    let { formStatus } = this.state;
    switch (formStatus) {
      case 'FORM_VISIBLE':
        return (
          <div className="stripePayment">
            <div className="std-form embedded-form">
              <PaymentSpringAchForm
                onSubmit={() =>
                  this._submitCharge({
                    type: 'PAYMENTSPRING',
                    token: {},
                  })
                }
                formattedPrice={this.props.formattedPrice || ''}
                totalPrice={this.props.totalPriceString || ''}
                handleFormChange={this._handleAchFormChange}
                formFields={this.state.paymentSpringAch}
                onAltPaymentClick={() => this.setState({ showAch: false })}
                achOnly={this.props.achOnly}
              />
            </div>
          </div>
        );
      case 'SUBMITTING':
        return (
          <div className="stripePayment">
            <div className="std-form embedded-form">
              <LoadingIndicator />
            </div>
          </div>
        );
      case 'SUCCESS': {
        return this._renderFormSuccess();
      }
      case 'ERROR':
        return this._renderFormError();
      default:
        return null;
    }
  }

  _submitCharge = async (charge: Charge) => {
    let {
      accountID: accountId,
      vendorID: vendorId,
      paymentspring_public_api_key,
      totalPriceNumber,
      invoiceId,
    } = this.props;
    if (!totalPriceNumber) {
      return;
    }
    this.setState({ formStatus: 'SUBMITTING' });
    switch (charge.type) {
      case 'STRIPE': {
        await postJSON(
          '/api/stripe/charge',
          {
            accountId,
            vendorId,
            stripeToken: charge.token,
            amount: totalPriceNumber,
            invoiceId,
          },
          this._paymentSubmitted,
        );
        break;
      }
      case 'PAYMENTSPRING': {
        if (this.state.showAch) {
          const {
            bank_account_number,
            bank_routing_number,
            bank_account_holder_first_name,
            bank_account_holder_last_name,
            bank_account_type,
          } = this.state.paymentSpringAch;
          if (
            !bank_account_number ||
            !bank_routing_number ||
            !bank_account_holder_first_name ||
            !bank_account_holder_last_name ||
            !bank_account_type
          ) {
            this._showError(
              `All payment fields must be filled ${bank_account_number}, ${bank_routing_number}, ${bank_account_holder_first_name}, ${bank_account_holder_last_name}, ${bank_account_type}`,
            );
            return;
          }
          if (!paymentspring_public_api_key) {
            this._showError('API Key not specified');
            return;
          }
          let publicApiResponse = await createPaymentSpringToken(
            {
              token_type: 'bank_account',
              bank_account_number,
              bank_routing_number,
              bank_account_holder_first_name,
              bank_account_holder_last_name,
              bank_account_type,
            },
            paymentspring_public_api_key,
          );
          if (typeof publicApiResponse?.id === 'string') {
            await postJSON(
              '/api/paymentSpring/achCharge',
              {
                tokenID: publicApiResponse.id,
                accountID: accountId,
                vendorID: vendorId,
                amount: this.props.totalPriceNumber ?? 0,
                invoiceId,
              },
              this._paymentSubmitted,
            );
          }
        } else if (this.state.paymentSpring) {
          let {
            card_exp_month,
            card_exp_year,
            card_number,
            cvv,
          } = this.state.paymentSpring;
          if (
            !this.state.showAch &&
            (!card_exp_month || !card_exp_year || !card_number || !cvv)
          ) {
            this._showError('All payment fields must be filled');
            return;
          }
          if (!paymentspring_public_api_key) {
            this._showError('API Key not specified');
            return;
          }
          let publicApiResponse = await createPaymentSpringToken(
            {
              token_type: 'credit_card',
              card_exp_month: Number(card_exp_month),
              card_exp_year: Number(card_exp_year),
              card_number,
              cvv,
            },
            paymentspring_public_api_key,
          );
          if (typeof publicApiResponse?.id === 'string') {
            await postJSON(
              '/api/paymentSpring/charge',
              {
                tokenID: publicApiResponse.id,
                accountID: accountId,
                vendorID: vendorId,
                amount: this.props.totalPriceNumber ?? 0,
                cvv,
                invoiceId,
              },
              this._paymentSubmitted,
            );
          }
        }
      }
    }
  };

  _showError(error: string) {
    // eslint-disable-next-line no-console
    console.error(error);
    showError(error);
    this.setState({ formStatus: 'FORM_VISIBLE' });
  }

  _paymentSubmitted(
    error:
      | {
          [key: string]: any;
        }
      | null
      | undefined,
    data_: any,
  ) {
    let data: DataType | null | undefined = data_;
    if (error) {
      this.setState({ formStatus: 'ERROR', formError: error.message });
    } else if (data) {
      if (data.success) {
        this.props.onSuccess?.();
        this.setState({ formStatus: 'SUCCESS' });
      } else {
        this.setState({ formStatus: 'ERROR', formError: data.error });
      }
    }
  }

  _handleFormChange(paymentSpring: PaymentSpringFormFields) {
    this.setState({ paymentSpring });
  }

  _handleAchFormChange(paymentSpringAch: PaymentSpringRequiredAchTokenParams) {
    this.setState({ paymentSpringAch });
  }

  _renderFormSuccess() {
    return (
      <Alert
        type="success"
        onDismiss={() => {
          this.props.onClose?.();
        }}
        text="Your payment has been processed successfully."
      />
    );
  }

  _renderFormError() {
    if (!this.state.formError) {
      return null;
    }
    return (
      <Alert
        type="error"
        onDismiss={() => {
          this.setState({ formStatus: 'FORM_VISIBLE', formError: null });
        }}
        text={this.state.formError}
      />
    );
  }
}

export default PaymentForm;
